import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../api';

const addOrderWithItems = async ({ createdBy, productId, price }) => {
  const { data: orderData, error: orderError } = await supabase
    .from('orders')
    .insert(
      {
        status: 'Pending',
        created_by: createdBy,
      }
    )
    .select('id');

  if (orderError) {
    throw new Error(`Order creation failed: ${orderError.message}`);
  }

  const orderId = orderData[0].id;

  const { data: orderItemData, error: orderItemError } = await supabase
    .from('order_items')
    .insert(
      {
        order_id: orderId,
        product: productId,
        price
      },
    );

  if (orderItemError) {
    throw new Error(`Order item creation failed: ${orderItemError.message}`);
  }

  return { orderId, orderItemData };
};

export default function useAddProductToBasket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addOrderWithItems,
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetOrdersInTheCart']);
      queryClient.invalidateQueries(['useGetOrders']);
    }
  });
}
